module.exports = __webpack_public_path__ + "img/yeshi.ca553b1a.jpg";